export class CloudDriveUrlResultDto {
    url: string;
}
